import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Calendar } from 'lucide-react';
import { CTAButton } from './CTAButton';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function HeroSection() {
  const painBullets = ['Si el No-Show te cuesta miles en tiempo y recursos cada mes', 'Si dependes de referencias médicas para conseguir pacientes nuevos', 'Si tus pacientes no regresan para los tratamientos de seguimiento', 'Si no apareces en Google cuando buscan tu especialidad en tu ciudad', 'Si estás perdiendo pacientes con tu competencia que tiene mejor presencia digital aunque no sea mejor clínica'];
  return <section className="min-h-screen bg-carbon pt-8 pb-16 px-5 sm:px-6 md:px-8" data-id="element-228">
      <div className="max-w-7xl mx-auto" data-id="element-229">
        {/* Top Bar - Logo */}
        <div className="mb-12 md:mb-20" data-id="element-230">
          <img src="https://cdn.magicpatterns.com/uploads/nanucanRnpywk3r4f9gVxT/IMG_6635.jpg" alt="Doctor Ecommerce Logo" className="h-10 md:h-12 w-auto" data-id="element-231" />
        </div>

        {/* Hero Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-232">
          {/* Left Column: Text Content */}
          <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full" data-id="element-233">
            <motion.div variants={itemVariants} className="mb-4" data-id="element-234">
              <span className="text-gold font-bold tracking-wider text-sm md:text-base uppercase" data-id="element-235">
                Doctor Ecommerce
              </span>
            </motion.div>

            <motion.h1 variants={itemVariants} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-white" data-id="element-236">
              ¿Tu clínica tiene citas canceladas,
              <br className="hidden md:block" data-id="element-237" />
              <span className="text-gray-400" data-id="element-238">sillas vacías y pacientes</span>
              <br className="hidden md:block" data-id="element-239" />
              <span className="text-gold" data-id="element-240">que no regresan?</span>
            </motion.h1>

            <motion.p variants={itemVariants} className="text-base sm:text-lg md:text-xl text-gray-300 mb-10 max-w-2xl leading-relaxed" data-id="element-241">
              Implementamos el{' '}
              <strong className="text-white font-bold" data-id="element-242">
                Sistema A.C.E.™ Clínico
              </strong>
              : el protocolo de adquisición de pacientes que llena tu agenda con
              personas que necesitan tus servicios específicos, tienen seguro o
              capacidad de pago y se convierten en pacientes recurrentes.
            </motion.p>

            <motion.div variants={itemVariants} className="mb-10 space-y-3 md:space-y-4 max-w-2xl" data-id="element-243">
              {painBullets.map((bullet, index) => <motion.div key={index} variants={itemVariants} className="flex items-start bg-white/5 p-4 rounded-lg border border-white/10" data-id="element-244">
                  <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 text-red-500 mr-3 md:mr-4 flex-shrink-0 mt-0.5" data-id="element-245" />
                  <span className="text-gray-200 text-sm sm:text-base md:text-lg leading-snug" data-id="element-246">
                    {bullet}
                  </span>
                </motion.div>)}
            </motion.div>

            <motion.div variants={itemVariants} className="flex flex-col items-start gap-4" data-id="element-247">
              <CTAButton text="QUIERO MÁS PACIENTES CALIFICADOS" data-id="element-248" />
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-yellow-400 hover:underline transition-colors text-sm md:text-base font-medium flex items-center" data-id="element-249">
                <Calendar className="w-4 h-4 mr-2" data-id="element-250" />O agenda directamente tu
                cita aquí
              </a>
            </motion.div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="w-full h-full flex items-center justify-center lg:justify-end" data-id="element-251">
            <div className="relative w-full max-w-lg lg:max-w-none aspect-[4/5] lg:aspect-auto lg:h-[800px] rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-252">
              <img src="https://cdn.magicpatterns.com/uploads/3WGqkcxSnyL4oG46UwQXyh/heylloyd-image-1773434197565.png" alt="Doctores caminando en hospital" className="w-full h-full object-cover object-center" data-id="element-253" />
              {/* Subtle gradient overlay to blend with the dark theme */}
              <div className="absolute inset-0 bg-gradient-to-t from-carbon via-transparent to-transparent opacity-60" data-id="element-254"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}